module.exports = __webpack_public_path__ + "static/media/planeje-proxima-viagem.bab073ec.png";